<template>
  <main>
    <article class="row left-align">
      <section class="col s12">
        <router-link to="/tickeradmin/listservices" class="blue-grey-text text-darken-4 strong">
          Security Master
        </router-link>
        > Edit Portfolio
      </section>
    </article>
    <h4>Edit Portfolio</h4>
    <article class="row">
      <section class="input-field col s3">
        <input type="number"
               placeholder="123456"
               class="validate"
               v-model="portfolio.id"
               pattern="^[0-9]+$"
               disabled
        >
        <label class="active">Portfolio ID</label>
      </section>
      <section class="input-field col s3">
        <select class="browser-default"
                v-model="payload.recommendation_type_id"
                v-if="recommendationTypes.length"
                :disabled="!$auth.hasRoles('admin')"
        >
          <option v-for="recommendationType of recommendationTypes" :key="recommendationType.id" :value="recommendationType.id">
            {{ recommendationType.name }}
          </option>
        </select>
        <label class="active">Recommendatio Type</label>
      </section>
      <section class="input-field col s3">
        <select class="browser-default"
                v-model="payload.portfolio_type_id"
                v-if="portfolioTypes.length"
                :disabled="!$auth.hasRoles('admin')"
        >
          <option v-for="portfolioType of portfolioTypes" :key="portfolioType.id" :value="portfolioType.id">
            {{ portfolioType.name }}
          </option>
        </select>
        <label class="active">Portfolio Type</label>
      </section>
      <section class="input-field col s3">
        <input type="text"
               placeholder="3.14159"
               class="validate"
               pattern="^[0-9]+\.?[0-9]*$"
               v-model="payload.multiplier"
               :disabled="!$auth.hasRoles('admin')"
        >
        <label class="active">Multiplier</label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s6">
        <input type="text"
               placeholder="Stock Advisor"
               class="validate"
               v-model="payload.name"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Name
        </label>
      </section>
      <section class="input-field col s6">
        <input type="text"
               placeholder=""
               class="validate"
               v-model="payload.slug"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Slug
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s4">
        <input id="ticker-admin-edit-portfolio-active-date"
               type="text"
               class="datepicker"
               v-model="portfolio.active_date"
               @change="payload.active_date = $event.target.value"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Active Date
        </label>
      </section>
      <section class="input-field col s4">
        <input id="ticker-admin-edit-portfolio-inactive-date"
               type="text"
               class="datepicker"
               v-model="portfolio.inactive_date"
               @change="payload.inactive_date = $event.target.value"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Inactive Date
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
      <section class="input-field col s4">
        <p>
          <label>
            <input type="checkbox" class="filled-in" v-model="payload.embargo_recs_until_publish" :disabled="!$auth.hasRoles('admin')" />
            <span>Embargo Recs Until Published</span>
          </label>
        </p>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s6">
        <select class="browser-default"
                v-model="payload.service_id"
                v-if="services.length"
        >
          <option v-for="service of services" :key="service.id" :value="service.id">
            #{{ service.id }} {{ service.name }}
          </option>
        </select>
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Service
        </label>
      </section>
      <section class="input-field col s3">
        <input type="number"
               placeholder=""
               class="validate"
               v-model="payload.apx_portfolio_id"
               :disabled="!$auth.hasRoles('admin')"
        >
        <label class="active">
          APX Portfolio ID
        </label>
      </section>
      <section class="input-field col s3">
        <input placeholder=""
               type="text"
               class="validate"
               v-model="payload.strategy"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Strategy
          <span class="grey-text text-lighten-1">(Optional)</span>
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s5">
        <select class="browser-default"
                v-model="payload.benchmark_id"
                v-if="benchmarks.length"
        >
          <option v-for="benchmark of benchmarks" :key="benchmark.id" :value="benchmark.id">
            {{ benchmark.name }} - {{ benchmark.symbol }}
          </option>
        </select>
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Benchmark
        </label>
      </section>
      <section class="input-field col s4">
        <select class="browser-default"
                v-model="payload.default_currency_id"
                v-if="currencies.length"
        >
          <option v-for="currency of currencies" :key="currency.id" :value="currency.id">
            {{ currency.name }} - {{ currency.symbol }}
          </option>
        </select>
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Default Currency
        </label>
      </section>
      <section class="input-field col s3">
        <input id="ticker-admin-edit-portfolio-frozen-date"
               type="text"
               class="datepicker"
               v-model="portfolio.frozen_date"
               @change="payload.frozen_date = $event.target.value"
        >
        <label class="active" :class="{'blue-text': !$auth.hasRoles('admin')}">
          Frozen Date
        </label>
      </section>
    </article>
    <article class="row">
      <section class="input-field col s3">
         <input type="number" step="0.01"
               placeholder="10000.00"
               :class="payload.portfolio_type_id === 1 ? 'validate' : 'hide validate'"
               v-model="payload.cash_commitment"
        >
        <label :class="payload.portfolio_type_id === 1 ? 'active' : 'hide'">Cash Commitment</label>
      </section>
    </article>
    <article class="row">
      <section class="col s9" />
      <section class="col s3">
        <input class="btn waves-effect waves-light right teal accent-4"
               type="submit"
               value="Submit"
               @click.prevent="savePortfolio"
        >
      </section>
    </article>
  </main>
</template>

<script>
import axios from 'axios';

const defaultPayload = {
  analyst_id: 0,
  portfolio_id: 0,
  recommendation_type_id: 0,
  portfolio_type_id: 0,
  multiplier: 0,
  name: '',
  slug: '',
  active_date: '',
  inactive_date: '',
  service_id: 0,
  apx_portfolio_id: 0,
  strategy: '',
  benchmark_id: 0,
  default_currency_id: 0,
  frozen_date: null,
  cash_commitment: 0,
  embargo_recs_until_publish: true,
};

export default {
  name: 'TickerAdminEditPortfolio',
  components: {},
  props: {},
  data() {
    return {
      services: [],
      recommendationTypes: [],
      portfolioTypes: [],
      benchmarks: [],
      currencies: [],
      portfolio: {
        service: {},
        recommendation_type: {},
        portfolio_type: {},
        benchmark: {},
        default_currency: {},
      },
      payload: { ...defaultPayload },
    };
  },
  computed: {
    portfolioId() {
      return Number(this.$route.query.portfolio_id);
    },
    body() {
      const body = {
        portfolio_id: this.payload.portfolio_id,
        analyst_id: this.payload.analyst_id,
      };
      if (this.payload.recommendation_type_id !== this.portfolio.recommendation_type.id) { body.recommendation_type_id = this.payload.recommendation_type_id; }
      if (this.payload.portfolio_type_id !== this.portfolio.portfolio_type.id) { body.portfolio_type_id = this.payload.portfolio_type_id; }
      if (this.payload.multiplier !== this.portfolio.multiplier) { body.multiplier = Number(this.payload.multiplier); }
      if (this.payload.name !== this.portfolio.name) { body.name = this.payload.name.trim(); }
      if (this.payload.slug !== this.portfolio.slug) { body.slug = this.payload.slug.trim(); }
      if (this.payload.active_date !== this.portfolio.active_date) { body.active_date = this.payload.active_date; }
      if (this.payload.inactive_date !== this.portfolio.inactive_date) {
        body.inactive_date = this.payload.inactive_date || null;
        body.active = !body.inactive_date;
      }
      if (this.payload.service_id !== this.portfolio.service.id) { body.service_id = this.payload.service_id; }
      if (this.payload.apx_portfolio_id !== this.portfolio.apx_portfolio_id) { body.apx_portfolio_id = Number(this.payload.apx_portfolio_id); }
      if (this.payload.strategy !== this.portfolio.strategy) { body.strategy = this.payload.strategy.trim(); }
      if (this.payload.benchmark_id !== this.portfolio.benchmark.id) { body.benchmark_id = this.payload.benchmark_id; }
      if (this.payload.default_currency_id !== this.portfolio.default_currency.id) { body.default_currency_id = this.payload.default_currency_id; }
      if (this.payload.frozen_date !== this.portfolio.frozen_date) { body.frozen_date = this.payload.frozen_date; }
      if (this.payload.cash_commitment !== this.portfolio.cash_commitment) { body.cash_commitment = this.payload.cash_commitment || 0; }
      if (this.payload.embargo_recs_until_publish !== this.portfolio.embargo_recs_until_publish) { body.embargo_recs_until_publish = this.payload.embargo_recs_until_publish }
      return body;
    },
  },
  watch: {},
  methods: {
    initDatepicker() {
      this.materialize.Datepicker.init(document.querySelectorAll('.datepicker'), {
        autoClose: false,
        format: 'yyyy-mm-dd',
        disableWeekends: true,
        showDaysInNextAndPreviousMonths: true,
        showClearBtn: true,
        onSelect() {},
      });
    },
    async fetchMetadata() {
      const promises = [
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/services/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/recommendation_types/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio_types/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/benchmarks/`),
        axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/instruments/currencies/`),
      ];
      const [servicesResp, recommendationTypesResp, portfolioTypesResp, benchmarksResp, currenciesResp] = await Promise.all(promises);
      [this.services, this.recommendationTypes, this.portfolioTypes, this.benchmarks, this.currencies] =
      [servicesResp.data, recommendationTypesResp.data, portfolioTypesResp.data, benchmarksResp.data, currenciesResp.data];
    },
    async fetchPortfolio() {
      const { data } = await axios.get(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio/?portfolio_id=${this.portfolioId}`);
      this.portfolio = data;
      this.payload.analyst_id = this.$auth.user.pk;
      this.payload.portfolio_id = this.portfolio.id;
      this.payload.recommendation_type_id = this.portfolio.recommendation_type.id;
      this.payload.portfolio_type_id = this.portfolio.portfolio_type.id;
      this.payload.multiplier = this.portfolio.multiplier;
      this.payload.name = this.portfolio.name;
      this.payload.slug = this.portfolio.slug;
      this.payload.active_date = this.portfolio.active_date;
      this.payload.inactive_date = this.portfolio.inactive_date;
      this.payload.service_id = this.portfolio.service.id;
      this.payload.apx_portfolio_id = this.portfolio.apx_portfolio_id;
      this.payload.strategy = this.portfolio.strategy;
      this.payload.benchmark_id = this.portfolio.benchmark.id;
      this.payload.default_currency_id = this.portfolio.default_currency.id;
      this.payload.frozen_date = this.portfolio.frozen_date;
      this.payload.cash_commitment = this.portfolio.cash_commitment;
      this.payload.embargo_recs_until_publish = this.portfolio.embargo_recs_until_publish;
    },
    async savePortfolio() {
      if (![
        this.body.analyst_id,
        this.body.portfolio_id,
      ].every(arg => Boolean(arg))) {
        return this.toast('Please populate all required fields', 'pink');
      }
      if (this.body.inactive_date && new Date(this.body.inactive_date) > new Date()) {
        return this.toast('Cannot enter an Inactive Date in the future', 'pink');
      }
      if (String(Object.keys(this.body)) === String(['portfolio_id', 'analyst_id'])) {
        return this.toast('Please modify at least one field', 'pink');
      }
      const { data } = await axios.put(`${this.$store.getters.VUE_APP_APING_URL}/insights/recommendations/portfolio/`, this.body);
      this.toast('Saved portfolio!', 'green');
      this.payload = { ...defaultPayload };
      document.getElementById('ticker-admin-edit-portfolio-active-date').value = '';
      document.getElementById('ticker-admin-edit-portfolio-inactive-date').value = '';
      this.fetchPortfolio();
    },
  },
  mounted() {
    this.fetchMetadata();
    this.fetchPortfolio();
    this.initDatepicker();
  },
};
</script>
